export default "{\n    \"label\": \"Usuario\"\n}\n"